import React, { useRef, useState, useEffect } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import i18n from "i18next";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button } from "@fluentui/react-components";
import { MegaphoneRegular } from "@fluentui/react-icons";
import Header from "../Header";

function Imprint(props: any) {
  const imprintDe = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<MegaphoneRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("imprint").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <p>
          Johannes Lübbering GmbH
          <br />
          Industriestraße 4<br />
          33442 Herzebrock-Clarholz
        </p>

        <p>
          <br />
          Handelsregister: HRB 5832
          <br />
          Registergericht: Amtsgericht Gütersloh
        </p>
        <div style={{ margin: "4px" }}></div>
        <p>
          <strong>Vertreten durch:</strong>
          <br />
          Achim Lübbering
        </p>
        <div style={{ margin: "15px" }}></div>
        <h2>Kontakt</h2>
        <p>
          Telefon: +49 (0) 5245 8309-0
          <br />
          E-Mail: info@luebbering.de
        </p>
        <div style={{ margin: "15px" }}></div>
        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
          <br />
          DE 811 256 260
        </p>
        <div style={{ margin: "15px" }}></div>
        <h2>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    </div>
  );

  const imprintEn = (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<MegaphoneRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("imprint").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <p>
          Johannes Lübbering GmbH
          <br />
          Industriestraße 4<br />
          33442 Herzebrock-Clarholz
          <br />
        </p>

        <p>
          Commercial Register: HRB 5832
          <br />
          Registration court: Amtsgericht Gütersloh
        </p>
        <div style={{ margin: "4px" }}></div>
        <p>
          <strong>Represented by:</strong>
          <br />
          Achim Lübbering
        </p>
        <div style={{ margin: "15px" }}></div>
        <h2>Contact</h2>
        <p>
          Phone: +49 (0) 5245 8309-0
          <br />
          E-mail: info@luebbering.de
        </p>
        <div style={{ margin: "15px" }}></div>
        <h2>VAT ID</h2>
        <p>
          Sales tax identification number according to Sect. 27 a of the Sales
          Tax Law:
          <br />
          DE 811 256 260
        </p>
        <div style={{ margin: "15px" }}></div>
        <h2>
          Dispute resolution proceedings in front of a consumer arbitration
          board
        </h2>
        <p>
          We are not willing or obliged to participate in dispute resolution
          proceedings in front of a consumer arbitration board.
        </p>
      </div>
    </div>
  );

  return i18n.language.includes("de") ? imprintDe : imprintEn;
}

export default Imprint;
